import { render, staticRenderFns } from "./MspLogoApp.vue?vue&type=template&id=1924df62"
import script from "./MspLogoApp.vue?vue&type=script&lang=js"
export * from "./MspLogoApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports